import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import {
  setLoading,
  saveData,
  setActivePage,
  setDropdownLoading,
  setCityOptions,
  setCitySelectedOptions
} from './actions';
import VendingMachine from './component';

class VendingMachineContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchName: '',
      searchId:'',
    };
  }

  componentDidMount() {
    // fetch all the permissions
    this.props.setLoading(true);
    this.props.setDropdownLoading(true);
    this.props.setActivePage(1);

    this.props.getDataFromAPI(
      `/vendingmachines/all`,
      'GET',
      undefined,
      response => {
        this.props.saveData(response);
        this.props.setLoading(false);
      },
      err => {
        this.props.setLoading(false);
        toastr.error('ERROR', err);
        console.log(err);
      }
    );
  }

  onSearchInputChange = (e, data) => {
    const searchName = data.value;
    this.setState({
      searchName
    });
  };

  onIdSearchChange = (e,data) => {
    const searchId = data.value;

    // to reset the search
    if (data.value === '') {
      return this.setState({
        searchId
      });
    }

    if (!/^\d+$/.test(searchId)) {
      return false;
    }

    this.setState((prev)=>({
      searchId
    }));
  }

  render() {
    const vmData = this.props.vms && this.props.vms.vmData && this.props.vms.vmData.list;
    const loading = this.props.vms && this.props.vms.loading;
    const {searchName,searchId}= this.state;

    const filteredVM =
      vmData && vmData.filter(
        vm => {
          if(!searchName && !searchId) return true;
          if(searchName && vm.name.toLowerCase().indexOf(searchName) !== -1 ) return true;
          if(searchId &&  String(vm.id).toLowerCase().startsWith(searchId) ) return true;
        }
           
      );
    

    return (
      <VendingMachine
        loading={loading}
        vmData={filteredVM}
        onSearchChnage={this.onSearchInputChange}
        onIdSearchChange={this.onIdSearchChange}
      />
    );
  }
}

function mapStateToProps({ vms }) {
  return {
    vms
  };
}

export default withRouter(
  connect(mapStateToProps, {
    getDataFromAPI,
    setLoading,
    saveData,
    setActivePage,
    setDropdownLoading,
    setCityOptions,
    setCitySelectedOptions
  })(VendingMachineContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/Sales&Inventory/container.jsx